import { CreditScore } from 'src/types/inputs';
import { InputValue } from 'src/redux/reducers/inputs';

export const determineIfPoorCredit = ({
  creditScoreQueryParam,
}: {
  creditScoreQueryParam?: InputValue;
}): boolean => creditScoreQueryParam === CreditScore.Poor;

export const determineIfAboveAverageCredit = ({
  creditScoreQueryParam,
}: {
  creditScoreQueryParam?: InputValue;
}): boolean =>
  creditScoreQueryParam === CreditScore.Excellent ||
  creditScoreQueryParam === CreditScore.Good;

export const CREDIT_SCORE_BANDS = {
  [CreditScore.LimitedCreditHistory]: [0, 0], //TODO - it should be defined here https://nerdwallet.atlassian.net/browse/CCIN-1340
  [CreditScore.Poor]: [300, 629],
  [CreditScore.Average]: [630, 689],
  [CreditScore.Good]: [690, 719],
  [CreditScore.Excellent]: [720, 850],
};

export const getCreditScoreBandFromScore = (
  creditScore: number
): CreditScore => {
  for (const [bandName, [min, max]] of Object.entries(CREDIT_SCORE_BANDS)) {
    if (
      typeof creditScore === 'number' &&
      creditScore >= min &&
      creditScore <= max
    ) {
      return bandName as CreditScore;
    }
  }

  return CreditScore.Average;
};

export const getCreditScoreText = (creditScore: CreditScore): string => {
  switch (creditScore) {
    case CreditScore.Excellent:
      return 'excellent';
    case CreditScore.Good:
      return 'good';
    case CreditScore.Poor:
      return 'bad';
    case CreditScore.LimitedCreditHistory:
      return 'limited history'; //TODO - it should be defined in https://nerdwallet.atlassian.net/browse/CCIN-1338
    case CreditScore.Average:
    default:
      return 'fair';
  }
};
